module.exports = {
	"articleTitle1": "Water pipe break damages Blue Leprechaun",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Blue Leprechaun",
	"articleLink1": "https://www.michigandaily.com/news/water-pipe-breakage-affects-south-u-businesses",
	"articleLink2": "https://www.michigandaily.com/content/new-bar-aims-reinvent-south-u-mainstay",
	"articleSnippet1": "Dec 18, 2013 ... The Blue Leprechaun, Bubble Island and Study Hall Lounge were damaged \nearly Wednesday morning by a water pipe breakage.",
	"articleSnippet2": "Sep 4, 2008 ... Though the Blue Leprechaun is co-owned by one of Touchdown Cafe's former \nowners and occupies the same space, General Manager Scott ...",
	"foodRecommendations": [],
	"articleTitle2": "New bar aims to reinvent South 'U' mainstay",
	"address": "1220 S University Ave, Ann Arbor, MI 48103",
	"images": [],
	"position": {
		"lat": 42.274783,
		"lng": -83.733317
	},
	"totalMisc": 0,
	"categories": {
		"nightlife": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/bluelep.json
// module id = 833
// module chunks = 0